export default __webpack_public_path__ + "static/media/FallBacklogo.24e47f9c.png";